import axios from "axios";
import {Loader} from '@googlemaps/js-api-loader';


export const useMapCommon = () => {
  const fetchLocation = async (locationId) => {
    let location = null;

    await axios.get(getLocationUrl(locationId), {withCredentials: false}).then(
      response => {
        location = response.data;
      });

    return location;
  }

  function getLocationUrl(locationId) {
    return '/map/locations/' + locationId;
  }

  const stringLatLngToNumberLatLng = (latLng) => {
    const lat = Number(latLng.lat);
    const lng = Number(latLng.lng);

    return {lat: lat, lng: lng};
  }

  // load google maps api
  const googleApiLoader = new Loader({
    apiKey: "AIzaSyBrOp6Lf34nrawOcrqm-1705cL6EeeDliQ",
    version: 'weekly',
    libraries: ['marker'],
  });

  const googleApiPromise = googleApiLoader.load();

  const urlQueryPersist = (url, route) => {

    const PERSISTENT_PARAMS = ['features', 'showAccessibleRoutes']

    const persisted = PERSISTENT_PARAMS
      .filter(key => route.query[key] !== undefined)
      .map(key => `${key}=${route.query[key]}`)
      .join('&')

    if (persisted) url += '&' + persisted


    return url
  }

  return {
    stringLatLngToNumberLatLng,
    fetchLocation,
    googleApiPromise,
    urlQueryPersist
  }
}
